import { createContext } from 'react';
import {
  ConfiguratorAZs,
  ConfiguratorCtx,
  ConfiguratorData,
} from './ConfiguratorContext.types';

export const ConfiguratorCtxValue: ConfiguratorCtx = {
  banners: null,
  setBanners: (state: ConfiguratorData | null) => {}, //eslint-disable-line
  azFromConfigurator: null,
  setAzFromConfigurator: (state: ConfiguratorAZs | null) => {}, // eslint-disable-line
};

export const configuratorContext = createContext(ConfiguratorCtxValue);
